export enum EmployerJobAdStatus {
  IN_REVIEW = 'IN_REVIEW',
  ACTIVE = 'ACTIVE',
  STOPPED = 'STOPPED',
  DISABLED = 'DISABLED',
  REJECTED = 'REJECTED',
}

export interface Employer {
  name: string;
}

export interface Principal {
  name: string;
}

export interface ThirdParty {
  name: string;
}

export interface SalaryDetails {
  starting: number;
  cap?: number;
  currency: string;
  currencyCode: string;
}

export interface Organization {
  id: string;
  name: string;
}

export interface Tag {
  id: string;
  name: string;
}

export enum DurationType {
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export interface DurationDetails {
  value: number;
  type: DurationType;
}

export enum EmploymentType {
  FULL_TIME = 'FULL_TIME',
  CONTRACT = 'CONTRACT',
}

export interface EmployerJobAdLocation {
  area: string;
  state: string;
  country: string;
}

export interface Application {
  id: string;
}

export interface EmployerJobAd {
  id: string;
  title: string;
  description: string;
  status: EmployerJobAdStatus;
  employmentType: EmploymentType;
  duration?: DurationDetails;
  salaryDetails?: SalaryDetails;
  location: EmployerJobAdLocation;
  tags: Tag[];
  organization: Organization & { id: string };
  principal?: Principal & { id: string };
  thirdParty?: ThirdParty;
  applications?: Application[];
  createdAt: string;
  updatedAt: string;
}

export interface AdminEmployerJobAdsResponse {
  edges: {
    cursor: string;
    node: EmployerJobAd;
  }[];
  pageInfo: {
    hasNextPage: boolean;
    hasPreviousPage: boolean;
    startCursor: string;
    endCursor: string;
  };
  totalCount: number;
}

export interface JobAdsFilters {
  statuses?: EmployerJobAdStatus[];
  employmentTypes?: EmploymentType[];
  organizationIds?: string[];
  principalIds?: string[];
  dateFrom?: string; // DateTimeISO string
  dateTo?: string; // DateTimeISO string
  searchTerm?: string;
}
